export default __webpack_public_path__ + "static/media/nytpic.1ca7c544.png";